module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/intervinientes/intervinientes.component.css
// module id = ./src/app/components/intervinientes/intervinientes.component.css
// module chunks = main